import React from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Header from "../Modal/Header";
import Actions from "../Modal/Actions";
import Content from "../Modal/Content";
import GlobalLoader from "../GlobalLoader";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { TextField } from "formik-material-ui";
import { addProfile } from "../../redux/actions/usersActions";
import { withRouter } from "react-router-dom";
const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    outline: "none",
    minWidth: 500,
    maxWidth: "500px",
  },
}));

function AddCoinPack(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const _handleSubmit = (values, formikApi) => {
    const { username } = values;
    const data = {
      firstname: username,
      lastname: username,
      username: username.toLowerCase(),
      email: username.toLowerCase() + "@gmail.com",
      password: "Flirtdart.2020",
      confirmPassword: "Flirtdart.2020",
      type: 2,
    };
    props.addProfile(data, formikApi, props.history);
  };

  return (
    <React.Fragment>
      <Button color='primary' variant='contained' onClick={handleOpen}>
        ADD NEW
      </Button>
      <Modal
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}>
        <Fade in={open}>
          <Paper className={classes.paper}>
            <Formik
              initialValues={{
                username: "",
              }}
              validationSchema={Yup.object().shape({
                username: Yup.string().required("Required"),
              })}
              onSubmit={_handleSubmit}>
              {({ submitForm, isSubmitting }) => (
                <Form>
                  {isSubmitting && <GlobalLoader></GlobalLoader>}
                  <Header title='Add new profile' />
                  <Content>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={12}>
                        <Field
                          component={TextField}
                          type='text'
                          margin='normal'
                          fullWidth
                          id='username'
                          label='Username'
                          name='username'
                          variant='outlined'
                        />
                      </Grid>
                    </Grid>
                  </Content>
                  <Actions>
                    <Button
                      color='primary'
                      onClick={handleClose}
                      style={{ marginRight: 15 }}>
                      Close
                    </Button>
                    <Button
                      type='submit'
                      variant='contained'
                      color='primary'
                      disabled={isSubmitting}
                      onClick={submitForm}>
                      Submit
                    </Button>
                  </Actions>
                </Form>
              )}
            </Formik>
          </Paper>
        </Fade>
      </Modal>
    </React.Fragment>
  );
}

export default withRouter(
  connect((state) => state, { addProfile })(AddCoinPack)
);
